// extracted by mini-css-extract-plugin
export default {"container":"post-poster-modal-spacer-module__container--XviMm"};